// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12974":"skin-copy","50169":"aria-labels"}[chunkId] || chunkId) + "-" + {"12974":"f245a4dcb37de128531d","15228":"90c6becfd884cb05da84","26796":"9d737196fe812f02d9da","40528":"53034777fd791228700a","50169":"ff23385368b5a702cdfe","73786":"e609469a7ade9605efb3"}[chunkId] + ".min.js";
};